import { Link } from "react-router-dom";
import { SITE } from "../config";
import { StoreButtons } from "./StoreButtons";
import { useConsent } from "../lib/consentContext";

const cols = [
  { title: "Product", links: [["Discover Your Intention", "/intention"], ["Features", "/features"], ["Experience HUMN", "/experience"], ["HumnAi Technology", "/slm"], ["How It Works", "/#how-it-works"], ["Credits", "/credits"], ["Download", "/download"]] },
  { title: "Company", links: [["About", "/about"], ["Contact", "/contact"], ["Support", "/support"]] },
  { title: "Trust", links: [["All Policies", "/policies"], ["Master Governance", "/master-policy"], ["Safety", "/safety"], ["Safety Policy", "/safety-policy"], ["Privacy Policy", "/privacy"], ["Terms of Service", "/terms"], ["HumnAi Policy", "/humnai-policy"], ["Credits Policy", "/credits-policy"], ["Community Guidelines", "/community-guidelines"], ["Content Policy", "/content-policy"], ["Creator Policy", "/creator-policy"], ["Cookie Policy", "/cookie-policy"], ["Refund Policy", "/refund-policy"]] },
];

export const Footer = () => {
  const { openPreferences } = useConsent();

  return (
  <footer className="scene scene-horizon text-white" style={{ background: "#05030a" }} data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 sm:px-10 pt-24 pb-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <span className="brand-lockup gap-3">
            <img src="/brand/humn-tile-dark.png" alt="" aria-hidden="true" className="h-11 w-11" />
            <img src="/brand/humn-wordmark.png" alt="HUMN" className="h-6 w-auto" />
          </span>
          <p className="eyebrow mt-5" style={{ color: "rgba(255,255,255,0.4)" }}>The Ai Social Network</p>
          <p className="text-white/45 text-sm leading-relaxed mt-4 max-w-xs">
            Say what you want to do. HUMN helps you find who and what can move it forward.
          </p>
          <StoreButtons placement="footer" dark className="mt-8" />
        </div>
        {cols.map((c) => (
          <div key={c.title} className="lg:col-span-2 first:lg:col-span-5">
            <p className="eyebrow eyebrow-dark mb-5">{c.title}</p>
            <ul className="space-y-3">
              {c.links.map(([label, to]) => (
                <li key={to}>
                  <Link to={to} data-testid={`footer-link-${to.replace("/", "")}`} className="text-[13px] text-white/55 hover:text-white transition-colors duration-200">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
        <div className="lg:col-span-3">
          <p className="eyebrow eyebrow-dark mb-5">Reach us</p>
          <ul className="space-y-3 text-[13px] text-white/55">
            <li><a href={`mailto:${SITE.contactEmail}`} className="hover:text-white transition-colors duration-200" data-testid="footer-contact-email">{SITE.contactEmail}</a></li>
            <li><a href={`mailto:${SITE.supportEmail}`} className="hover:text-white transition-colors duration-200" data-testid="footer-support-email">{SITE.supportEmail}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-20 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-[12px] text-white/35">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} {SITE.companyName}. All rights reserved.</p>
        <div className="flex gap-6">
          <button type="button" onClick={(event) => openPreferences(event.currentTarget)} className="hover:text-white transition-colors duration-200" data-testid="footer-cookie-preferences">Cookie preferences</button>
          <Link to="/privacy" className="hover:text-white transition-colors duration-200" data-testid="footer-privacy-short-link">Privacy</Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
